import { TFunction } from "i18next";

export interface Lifeline {
  id: string;
  name: string;
  description: string;
  icon: string;
  type: LifelineType;
  shouldChooseBeforeQuestion: boolean;
  disabled: boolean;
  selected: boolean;
}

export const getLifelines = (
  t: TFunction<"translation", undefined>
): Array<Lifeline> => [
  {
    id: "1",
    name: t("double_points"),
    description: t("double_points_description"),
    icon: require("../../assets/images/lifelines/double_points.png"),
    type: LifelineType.DOUBLE_POINT,
    shouldChooseBeforeQuestion: true,
    disabled: false,
    selected: false,
  },
  {
    id: "2",
    name: t("trap"),
    description: t("trap_description"),
    icon: require("../../assets/images/lifelines/trap.png"),
    type: LifelineType.TRAP,
    shouldChooseBeforeQuestion: true,
    disabled: false,
    selected: false,
  },
  {
    id: "3",
    name: t("insurance"),
    description: t("insurance_description"),
    icon: require("../../assets/images/lifelines/insurance.png"),
    type: LifelineType.INSURANCE,
    shouldChooseBeforeQuestion: true,
    disabled: false,
    selected: false,
  },
  {
    id: "4",
    name: t("two_answers"),
    description: t("two_answers_description"),
    icon: require("../../assets/images/lifelines/two_answers.png"),
    type: LifelineType.TWO_ANSWERS,
    shouldChooseBeforeQuestion: false,
    disabled: false,
    selected: false,
  },
  {
    id: "5",
    name: t("call_friend"),
    description: t("call_friend_description"),
    icon: require("../../assets/images/lifelines/call_a_friend.png"),
    type: LifelineType.CALL_FRIEND,
    shouldChooseBeforeQuestion: false,
    disabled: false,
    selected: false,
  },
  {
    id: "6",
    name: t("extra_time"),
    description: t("extra_time_description"),
    icon: require("../../assets/images/lifelines/extra_time.png"),
    type: LifelineType.EXTRA_TIME,
    shouldChooseBeforeQuestion: false,
    disabled: false,
    selected: false,
  },
  {
    id: "7",
    name: t("tie_breaker"),
    description: t("tie_breaker_description"),
    icon: require("../../assets/images/lifelines/tie_breaker.png"),
    type: LifelineType.TIE_BREAKER,
    shouldChooseBeforeQuestion: false,
    disabled: false,
    selected: false,
  },
];

export enum LifelineType {
  DOUBLE_POINT = "doublePoints",
  TRAP = "trap",
  DARE = "dare",
  INSURANCE = "insurance",
  TWO_ANSWERS = "twoAnswers",
  CALL_FRIEND = "callFriend",
  EXTRA_TIME = "extraTime",
  TIE_BREAKER = "tieBreaker",
}
